module.exports = {"150404001":"振兴街道","150404002":"向阳街道","150404003":"松州街道","150404004":"铁东街道","150404100":"穆家营子镇","150404101":"初头朗镇","150404102":"大庙镇","150404103":"王府镇","150404104":"老府镇","150404105":"哈拉道口镇","150404106":"上官地镇","150404107":"安庆镇","150404108":"太平地镇","150404200":"当铺地满族乡","150404201":"夏家店乡","150404202":"城子乡","150404203":"大夫营子乡","150404204":"岗子乡","150404400":"玉龙街道","150404401":"全宁街道","150404407":"兴安街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150404.json
// module id = 372
// module chunks = 0